import type { RouteComponentProps } from '@reach/router';
import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';

import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';
import ShareCollectionButton from '@components/ShareButton/ShareCollectionButton';

import { useGetLabDiagnosticReports } from '@hooks/api/diagnostic-report';

import { ShareType } from 'generated/types';

import LabResults from './Main';

const LabResultsList: React.FC<RouteComponentProps> = () => {
  // Fetch all lab results
  const {
    data: { data },
    loading,
  } = useGetLabDiagnosticReports();

  return (
    <>
      <ShareCollectionButton share_type={ShareType.LabResults} />
      <LabResults data={data} loading={loading} />
    </>
  );
};

export default withErrorBoundary(LabResultsList, {
  FallbackComponent: ErrorBoundaryFallback,
});
